import { AnySendingSearchParams, DashboardSearchParams } from '@domain/types';

// Add any new user-facing filter field here. Omitting one causes stale
// filtered caches to be updated in place instead of invalidated.
export const ACTIVE_FILTER_FIELDS: (keyof DashboardSearchParams)[] = [
  'verificationStatus',
  'selectedStatusFilter',
  'selectedStatusesFilter',
  'documentType',
  'searchPatient',
  'medium',
  'selectedMediumFilter',
  'hideOtherRequesters',
];

// An empty list is the multi-select's "nothing chosen": it narrows nothing, so it is not active.
export const hasActiveFilters = (searchParams: AnySendingSearchParams): boolean =>
  ACTIVE_FILTER_FIELDS.some((field) => {
    const value = (searchParams as DashboardSearchParams)[field];

    return value != null && value !== false && !(Array.isArray(value) && value.length === 0);
  });
